<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">
  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
    <div>
      <div class="flex sm:flex-row gap-2">
        <!-- <div>
                    <div>
                        <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date"
                            [owlDateTimeTrigger]="date" [selectMode]="'range'" />
                        <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="onDateChange($event)"
                            #date></owl-date-time>
                    </div>
                </div> -->
        <!-- <div *ngIf="setTab ==='company'">
                    <ng-select class="w-full sm:w-44" [(ngModel)]="selectedCompany" (change)="filterBySelection()" [clearable]="false">
                        <ng-option value="">Select Company</ng-option>
                        <ng-option *ngFor="let company of allCompanies" [value]="company">{{ company.name | titlecase }}
                        </ng-option>
                    </ng-select>
                </div> -->
        <!-- <div *ngIf="setTab ==='fundingsource'">
                    <ng-select class="w-full sm:w-44" [(ngModel)]="selectedFundingsource" (change)="filterBySelection()" [clearable]="false"
                        [searchable]="true">
                        <ng-option value="">Select FS</ng-option>
                        <ng-option *ngFor="let fundingsource of fundingSourceList" [value]="fundingsource">{{
                            fundingsource.title
                            | titlecase }}</ng-option>
                    </ng-select>
                </div> -->
      </div>
    </div>
    <!-- <div class="flex flex-col sm:flex-row gap-2">
            <div
                class="inline-flex flex-wrap p-1 rounded-lg gap-0.5 bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg focus:outline-none">

                <div [ngClass]="setTab === 'company' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeState('company')" class="cursor-pointer">
                    Company Wise
                </div>
                <div [ngClass]="setTab === 'fundingsource' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeState('fundingsource')" class="cursor-pointer">
                    Funding Source Wise
                </div>
            </div>
              <div
                class="inline-flex flex-wrap p-1 rounded-lg gap-0.5 bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg focus:outline-none">

                <div [ngClass]="source === 'original' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeSource('original')" class="cursor-pointer">
                    Original
                </div>
                <div [ngClass]="source === 'billing' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeSource('billing')" class="cursor-pointer">
                    Company Adjusted
                </div>
                <div [ngClass]="source === 'fundingsource' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeSource('fundingsource')" class="cursor-pointer">
                    Funding Source Adjusted
                </div>
            </div>
            <button class="btn btn-secondary" (click)="generateKpiData()">
                Download
            </button>

        </div> -->
  </div>
  <div class="overflow-y-auto" [style.height.px]="cardsPanelHeight">
  <div class="flex items-center justify-between mb-1">
    <h2 class="text-xl font-semibold text-gray-800 dark:text-white">Company</h2>
    <!-- <div *ngIf="companyStats && companyStats.length" class="text-xs text-nowrap text-gray-500 dark:text-gray-400">
      Showing {{ (50 * currentPage) - (companyStats.length != 50 ? (50 -
      companyStats.length) : 0) }} of {{ totalResults }} entries
    </div> -->
    <div class="flex flex-col sm:flex-row gap-2">
      <div class="w-full sm:w-56">
        <select id="windowDays" class="w-full" [(ngModel)]="windowDays" (change)="onWindowDaysChange()">
          <option *ngFor="let days of windowDaysOptions" [ngValue]="days">Expiring within {{ days }} Days</option>
        </select>
      </div>
      <div class="w-full sm:w-48">
        <ng-select id="" class="" [(ngModel)]="selectedCompany" (change)="onCompanyChange()" [clearable]="false">
          <ng-option value="">Select Company</ng-option>
          <ng-option *ngFor="let company of companies" value="{{company.id}}">{{ company.name | titlecase }}</ng-option>
        </ng-select>
      </div>
    </div>
  </div>
  
  <div class="flex flex-wrap gap-2">
    <div
      class="rounded-lg bg-white dark:bg-zinc-950 shadow border border-zinc-200 dark:border-zinc-800 px-2 py-1.5 flex flex-col items-center transition-all duration-200 w-40">
      <div class="text-gray-500 dark:text-gray-300 text-xs mb-0.5">Fraud Waste & Abuse</div>
      <button class="text-sm font-bold text-red-600 hover:underline" (click)="openExpiredDocsModal(null, 'company', 'documents.fraudWasteAndAbuseCertificateExpireDate', 'expired', documentStats?.company?.documents?.fraudWasteAndAbuseCertificateExpireDate?.expired || 0)">
        Expired: {{ documentStats?.company?.documents?.fraudWasteAndAbuseCertificateExpireDate?.expired || 0 }}
      </button>
      <button class="text-yellow-500 text-xs mt-0.5 hover:underline" (click)="openExpiredDocsModal(null, 'company', 'documents.fraudWasteAndAbuseCertificateExpireDate', 'willExpire', documentStats?.company?.documents?.fraudWasteAndAbuseCertificateExpireDate?.willExpire || 0)">
        Will Expire: {{ documentStats?.company?.documents?.fraudWasteAndAbuseCertificateExpireDate?.willExpire || 0 }}
      </button>
    </div>

    <div
      class="rounded-lg bg-white dark:bg-zinc-950 shadow border border-zinc-200 dark:border-zinc-800 px-2 py-1.5 flex flex-col items-center transition-all duration-200 w-40">
      <div class="text-gray-500 dark:text-gray-300 text-xs mb-0.5">HIPAA Training</div>
      <button class="text-sm font-bold text-red-600 hover:underline" (click)="openExpiredDocsModal(null, 'company', 'documents.hIPAATrainingExpireDate', 'expired', documentStats?.company?.documents?.hIPAATrainingExpireDate?.expired || 0)">
        Expired: {{ documentStats?.company?.documents?.hIPAATrainingExpireDate?.expired || 0 }}
      </button>
      <button class="text-yellow-500 text-xs mt-0.5 hover:underline" (click)="openExpiredDocsModal(null, 'company', 'documents.hIPAATrainingExpireDate', 'willExpire', documentStats?.company?.documents?.hIPAATrainingExpireDate?.willExpire || 0)">
        Will Expire: {{ documentStats?.company?.documents?.hIPAATrainingExpireDate?.willExpire || 0 }}
      </button>
    </div>

    <div
      class="rounded-lg bg-white dark:bg-zinc-950 shadow border border-zinc-200 dark:border-zinc-800 px-2 py-1.5 flex flex-col items-center transition-all duration-200 w-40">
      <div class="text-gray-500 dark:text-gray-300 text-xs mb-0.5">Auto Liability</div>
      <button class="text-sm font-bold text-red-600 hover:underline" (click)="openExpiredDocsModal(null, 'company', 'insurance.autoLiabilityInsuranceExpireDate', 'expired', documentStats?.company?.insurance?.autoLiabilityInsuranceExpireDate?.expired || 0)">
        Expired: {{ documentStats?.company?.insurance?.autoLiabilityInsuranceExpireDate?.expired || 0 }}
      </button>
      <button class="text-yellow-500 text-xs mt-0.5 hover:underline" (click)="openExpiredDocsModal(null, 'company', 'insurance.autoLiabilityInsuranceExpireDate', 'willExpire', documentStats?.company?.insurance?.autoLiabilityInsuranceExpireDate?.willExpire || 0)">
        Will Expire: {{ documentStats?.company?.insurance?.autoLiabilityInsuranceExpireDate?.willExpire || 0 }}
      </button>
    </div>

    <div
      class="rounded-lg bg-white dark:bg-zinc-950 shadow border border-zinc-200 dark:border-zinc-800 px-2 py-1.5 flex flex-col items-center transition-all duration-200 w-40">
      <div class="text-gray-500 dark:text-gray-300 text-xs mb-0.5">General Liability</div>
      <button class="text-sm font-bold text-red-600 hover:underline" (click)="openExpiredDocsModal(null, 'company', 'insurance.generalLiabilityInsuranceExpireDate', 'expired', documentStats?.company?.insurance?.generalLiabilityInsuranceExpireDate?.expired || 0)">
        Expired: {{ documentStats?.company?.insurance?.generalLiabilityInsuranceExpireDate?.expired || 0 }}
      </button>
      <button class="text-yellow-500 text-xs mt-0.5 hover:underline" (click)="openExpiredDocsModal(null, 'company', 'insurance.generalLiabilityInsuranceExpireDate', 'willExpire', documentStats?.company?.insurance?.generalLiabilityInsuranceExpireDate?.willExpire || 0)">
        Will Expire: {{ documentStats?.company?.insurance?.generalLiabilityInsuranceExpireDate?.willExpire || 0 }}
      </button>
    </div>
  </div>

  <h2 class="text-xl font-semibold mb-1 text-gray-800 dark:text-white">Driver</h2>

  <div class="flex flex-wrap gap-2">
    <div
      class="rounded-lg bg-white dark:bg-zinc-950 shadow border border-zinc-200 dark:border-zinc-800 px-2 py-1.5 flex flex-col items-center transition-all duration-200 w-40">
      <div class="text-gray-500 dark:text-gray-300 text-xs mb-0.5">Physical Exam</div>
      <button class="text-sm font-bold text-red-600 hover:underline" (click)="openExpiredDocsModal(null, 'driver', 'examinations.phyExamExpireDate', 'expired', documentStats?.driver?.examinations?.phyExamExpireDate?.expired || 0)">
        Expired: {{ documentStats?.driver?.examinations?.phyExamExpireDate?.expired || 0 }}
      </button>
      <button class="text-yellow-500 text-xs mt-0.5 hover:underline" (click)="openExpiredDocsModal(null, 'driver', 'examinations.phyExamExpireDate', 'willExpire', documentStats?.driver?.examinations?.phyExamExpireDate?.willExpire || 0)">
        Will Expire: {{ documentStats?.driver?.examinations?.phyExamExpireDate?.willExpire || 0 }}
      </button>
    </div>

    <div
      class="rounded-lg bg-white dark:bg-zinc-950 shadow border border-zinc-200 dark:border-zinc-800 px-2 py-1.5 flex flex-col items-center transition-all duration-200 w-40">
      <div class="text-gray-500 dark:text-gray-300 text-xs mb-0.5">Drug Test</div>
      <button class="text-sm font-bold text-red-600 hover:underline" (click)="openExpiredDocsModal(null, 'driver', 'examinations.drugTestExpireDate', 'expired', documentStats?.driver?.examinations?.drugTestExpireDate?.expired || 0)">
        Expired: {{ documentStats?.driver?.examinations?.drugTestExpireDate?.expired || 0 }}
      </button>
      <button class="text-yellow-500 text-xs mt-0.5 hover:underline" (click)="openExpiredDocsModal(null, 'driver', 'examinations.drugTestExpireDate', 'willExpire', documentStats?.driver?.examinations?.drugTestExpireDate?.willExpire || 0)">
        Will Expire: {{ documentStats?.driver?.examinations?.drugTestExpireDate?.willExpire || 0 }}
      </button>
    </div>

    <div
      class="rounded-lg bg-white dark:bg-zinc-950 shadow border border-zinc-200 dark:border-zinc-800 px-2 py-1.5 flex flex-col items-center transition-all duration-200 w-40">
      <div class="text-gray-500 dark:text-gray-300 text-xs mb-0.5">Driver License</div>
      <button class="text-sm font-bold text-red-600 hover:underline" (click)="openExpiredDocsModal(null, 'driver', 'driverLicense.expireDate', 'expired', documentStats?.driver?.driverLicense?.expireDate?.expired || 0)">
        Expired: {{ documentStats?.driver?.driverLicense?.expireDate?.expired || 0 }}
      </button>
      <button class="text-yellow-500 text-xs mt-0.5 hover:underline" (click)="openExpiredDocsModal(null, 'driver', 'driverLicense.expireDate', 'willExpire', documentStats?.driver?.driverLicense?.expireDate?.willExpire || 0)">
        Will Expire: {{ documentStats?.driver?.driverLicense?.expireDate?.willExpire || 0 }}
      </button>
    </div>
  </div>

  <h2 class="text-xl font-semibold mb-3 text-gray-800 dark:text-white">Vehicle</h2>

  <div class="flex flex-wrap gap-2">
    <div
      class="rounded-lg bg-white dark:bg-zinc-950 shadow border border-zinc-200 dark:border-zinc-800 px-2 py-1.5 flex flex-col items-center transition-all duration-200 w-40">
      <div class="text-gray-500 dark:text-gray-300 text-xs mb-0.5">Registration</div>
      <button class="text-sm font-bold text-red-600 hover:underline" (click)="openExpiredDocsModal(null, 'vehicle', 'dates.registrationExpireDate', 'expired', documentStats?.vehicle?.dates?.registrationExpireDate?.expired || 0)">
        Expired: {{ documentStats?.vehicle?.dates?.registrationExpireDate?.expired || 0 }}
      </button>
      <button class="text-yellow-500 text-xs mt-0.5 hover:underline" (click)="openExpiredDocsModal(null, 'vehicle', 'dates.registrationExpireDate', 'willExpire', documentStats?.vehicle?.dates?.registrationExpireDate?.willExpire || 0)">
        Will Expire: {{ documentStats?.vehicle?.dates?.registrationExpireDate?.willExpire || 0 }}
      </button>
    </div>

    <div
      class="rounded-lg bg-white dark:bg-zinc-950 shadow border border-zinc-200 dark:border-zinc-800 px-2 py-1.5 flex flex-col items-center transition-all duration-200 w-40">
      <div class="text-gray-500 dark:text-gray-300 text-xs mb-0.5">Inspection</div>
      <button class="text-sm font-bold text-red-600 hover:underline" (click)="openExpiredDocsModal(null, 'vehicle', 'dates.inspectionExpireDate', 'expired', documentStats?.vehicle?.dates?.inspectionExpireDate?.expired || 0)">
        Expired: {{ documentStats?.vehicle?.dates?.inspectionExpireDate?.expired || 0 }}
      </button>
      <button class="text-yellow-500 text-xs mt-0.5 hover:underline" (click)="openExpiredDocsModal(null, 'vehicle', 'dates.inspectionExpireDate', 'willExpire', documentStats?.vehicle?.dates?.inspectionExpireDate?.willExpire || 0)">
        Will Expire: {{ documentStats?.vehicle?.dates?.inspectionExpireDate?.willExpire || 0 }}
      </button>
    </div>
  </div>
  </div>

  <div class="group h-6 flex items-center justify-center gap-2 cursor-row-resize select-none shrink-0"
    (mousedown)="startResize($event)">
    <div class="w-12 h-1 rounded-full bg-zinc-300 dark:bg-zinc-700 group-hover:bg-zinc-400 dark:group-hover:bg-zinc-500 transition-colors">
    </div>
    <button *ngIf="cardsPanelHeight !== DEFAULT_CARDS_PANEL_HEIGHT" type="button" title="Reset panel size"
      class="flex items-center gap-1 text-[11px] leading-none px-2 py-1 rounded-full border border-zinc-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 text-zinc-500 dark:text-zinc-400 shadow-sm hover:bg-zinc-100 dark:hover:bg-zinc-800 hover:text-zinc-700 dark:hover:text-zinc-200 transition-colors cursor-pointer"
      (mousedown)="$event.stopPropagation()" (click)="resetCardsPanelHeight()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
        <path fill-rule="evenodd"
          d="M15.312 11.424a5.5 5.5 0 01-9.201 2.466l-.312-.311h2.433a.75.75 0 000-1.5H3.989a.75.75 0 00-.75.75v4.242a.75.75 0 001.5 0v-2.43l.31.31a7 7 0 0011.712-3.138.75.75 0 00-1.449-.39zm1.23-3.723a.75.75 0 00.219-.53V2.929a.75.75 0 00-1.5 0V5.36l-.31-.31A7 7 0 003.239 8.188a.75.75 0 101.448.389A5.5 5.5 0 0113.89 6.11l.311.31h-2.432a.75.75 0 000 1.5h4.243a.75.75 0 00.53-.219z"
          clip-rule="evenodd" />
      </svg>
      Reset
    </button>
  </div>

  <div
    class="flex-1 min-h-0 overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
      <div class="flow-root h-full overflow-y-auto">
        <div class="-my-2">
          <div class="inline-block min-w-full py-2 align-middle">
            <table class="min-w-full border-separate border-spacing-0">
              <thead class="sticky top-0 z-50">
  
                <!-- ROW 1 -->
                <tr>
                  <th rowspan="3"
                    class="sticky z-20 left-0 top-0 border-r px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Company
                  </th>
                  <th colspan="8"
                    class="border-r px-3 py-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Company
                  </th>
                  <th colspan="6"
                    class="border-r px-3 py-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Driver
                  </th>
                  <th colspan="4"
                    class="border-r px-3 py-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Vehicle
                  </th>
                </tr>
  
                <!-- ROW 2 -->
                <tr>
                  <th colspan="2"
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Fraud Waste & Abuse</th>
                  <th colspan="2"
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    HIPAA Training</th>
                  <th colspan="2"
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Auto Liability</th>
                  <th colspan="2"
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    General Liability</th>
                  <th colspan="2"
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Physical Exam</th>
                  <th colspan="2"
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Drug Test</th>
                  <th colspan="2"
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Driver License</th>
                  <th colspan="2"
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Registration</th>
                  <th colspan="2"
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Inspection</th>
                </tr>
  
                <!-- ROW 3 -->
                <tr>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Expired</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Will Expire</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Expired</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Will Expire</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Expired</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Will Expire</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Expired</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Will Expire</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Expired</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Will Expire</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Expired</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Will Expire</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Expired</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Will Expire</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Expired</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Will Expire</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Expired</th>
                  <th
                    class="border-r px-1 text-center font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Will Expire</th>
                </tr>
  
              </thead>
  
              <tbody>
              <tr
                *ngFor="let item of companyStats"
                class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                  <td
                    class="sticky z-20 left-0 top-0 bg-gray-100 dark:bg-gray-950 px-2 border-r text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap font-medium">
                  {{ item?.companyName | titlecase }}
                  </td>
              
                  <!-- Fraud Waste & Abuse -->
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'company', 'documents.fraudWasteAndAbuseCertificateExpireDate', 'expired', item?.company?.documents?.fraudWasteAndAbuseCertificateExpireDate?.expired || 0)">
                      {{ item?.company?.documents?.fraudWasteAndAbuseCertificateExpireDate?.expired || 0 }}
                    </button>
                  </td>
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'company', 'documents.fraudWasteAndAbuseCertificateExpireDate', 'willExpire', item?.company?.documents?.fraudWasteAndAbuseCertificateExpireDate?.willExpire || 0)">
                      {{ item?.company?.documents?.fraudWasteAndAbuseCertificateExpireDate?.willExpire || 0 }}
                    </button>
                  </td>

                  <!-- HIPAA Training -->
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'company', 'documents.hIPAATrainingExpireDate', 'expired', item?.company?.documents?.hIPAATrainingExpireDate?.expired || 0)">
                      {{ item?.company?.documents?.hIPAATrainingExpireDate?.expired || 0 }}
                    </button>
                  </td>
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'company', 'documents.hIPAATrainingExpireDate', 'willExpire', item?.company?.documents?.hIPAATrainingExpireDate?.willExpire || 0)">
                      {{ item?.company?.documents?.hIPAATrainingExpireDate?.willExpire || 0 }}
                    </button>
                  </td>

                  <!-- Auto Liability -->
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'company', 'insurance.autoLiabilityInsuranceExpireDate', 'expired', item?.company?.insurance?.autoLiabilityInsuranceExpireDate?.expired || 0)">
                      {{ item?.company?.insurance?.autoLiabilityInsuranceExpireDate?.expired || 0 }}
                    </button>
                  </td>
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'company', 'insurance.autoLiabilityInsuranceExpireDate', 'willExpire', item?.company?.insurance?.autoLiabilityInsuranceExpireDate?.willExpire || 0)">
                      {{ item?.company?.insurance?.autoLiabilityInsuranceExpireDate?.willExpire || 0 }}
                    </button>
                  </td>

                  <!-- General Liability -->
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'company', 'insurance.generalLiabilityInsuranceExpireDate', 'expired', item?.company?.insurance?.generalLiabilityInsuranceExpireDate?.expired || 0)">
                      {{ item?.company?.insurance?.generalLiabilityInsuranceExpireDate?.expired || 0 }}
                    </button>
                  </td>
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'company', 'insurance.generalLiabilityInsuranceExpireDate', 'willExpire', item?.company?.insurance?.generalLiabilityInsuranceExpireDate?.willExpire || 0)">
                      {{ item?.company?.insurance?.generalLiabilityInsuranceExpireDate?.willExpire || 0 }}
                    </button>
                  </td>

                  <!-- Physical Exam -->
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'driver', 'examinations.phyExamExpireDate', 'expired', item?.driver?.examinations?.phyExamExpireDate?.expired || 0)">
                      {{ item?.driver?.examinations?.phyExamExpireDate?.expired || 0 }}
                    </button>
                  </td>
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'driver', 'examinations.phyExamExpireDate', 'willExpire', item?.driver?.examinations?.phyExamExpireDate?.willExpire || 0)">
                      {{ item?.driver?.examinations?.phyExamExpireDate?.willExpire || 0 }}
                    </button>
                  </td>

                  <!-- Drug Test -->
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'driver', 'examinations.drugTestExpireDate', 'expired', item?.driver?.examinations?.drugTestExpireDate?.expired || 0)">
                      {{ item?.driver?.examinations?.drugTestExpireDate?.expired || 0 }}
                    </button>
                  </td>
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'driver', 'examinations.drugTestExpireDate', 'willExpire', item?.driver?.examinations?.drugTestExpireDate?.willExpire || 0)">
                      {{ item?.driver?.examinations?.drugTestExpireDate?.willExpire || 0 }}
                    </button>
                  </td>

                  <!-- Driver License -->
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'driver', 'driverLicense.expireDate', 'expired', item?.driver?.driverLicense?.expireDate?.expired || 0)">
                      {{ item?.driver?.driverLicense?.expireDate?.expired || 0 }}
                    </button>
                  </td>
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'driver', 'driverLicense.expireDate', 'willExpire', item?.driver?.driverLicense?.expireDate?.willExpire || 0)">
                      {{ item?.driver?.driverLicense?.expireDate?.willExpire || 0 }}
                    </button>
                  </td>

                  <!-- Registration -->
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'vehicle', 'dates.registrationExpireDate', 'expired', item?.vehicle?.dates?.registrationExpireDate?.expired || 0)">
                      {{ item?.vehicle?.dates?.registrationExpireDate?.expired || 0 }}
                    </button>
                  </td>
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'vehicle', 'dates.registrationExpireDate', 'willExpire', item?.vehicle?.dates?.registrationExpireDate?.willExpire || 0)">
                      {{ item?.vehicle?.dates?.registrationExpireDate?.willExpire || 0 }}
                    </button>
                  </td>

                  <!-- Inspection -->
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'vehicle', 'dates.inspectionExpireDate', 'expired', item?.vehicle?.dates?.inspectionExpireDate?.expired || 0)">
                      {{ item?.vehicle?.dates?.inspectionExpireDate?.expired || 0 }}
                    </button>
                  </td>
                  <td class="px-1 border-r text-center text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <button class="hover:underline" (click)="openExpiredDocsModal(item.companyId, 'vehicle', 'dates.inspectionExpireDate', 'willExpire', item?.vehicle?.dates?.inspectionExpireDate?.willExpire || 0)">
                      {{ item?.vehicle?.dates?.inspectionExpireDate?.willExpire || 0 }}
                    </button>
                  </td>
              
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-expired-documents-modal *ngIf="expiredDocsModalObj" [data]="expiredDocsModalObj" (closeModal)="onCloseExpiredDocsModal()"></app-expired-documents-modal>